/*
 *  This file app.component.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */

import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from "@angular/router";
import { SharedService } from './global/services/shared.service';
import { Title } from '@angular/platform-browser';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false
})
export class AppComponent implements OnInit {
  isLoggedIn = !!JSON.parse(localStorage.getItem('authlogin') ?? 'null');
  mobileDisclaimerShown = false;
  isMobile = true;
  showRedirectDialogForTeams = false;
  flashLoader = "/assets/images/init-loader-1.svg";
  flashLoaderGT = "assets/images/dynamic_images/loader-2.svg";
  title = 'app';
  public isShowingRouteLoadIndicator: boolean = false;
  isPageLoading: boolean = false;
  isTimeOut: boolean = false;
  isClientConfig = true;
  constructor(
    public router: Router,
    public _shared: SharedService,
    private readonly titleService: Title,
  ) {
    const isGTInstance = this._shared.isDeployedOnGT;
    localStorage.removeItem('analyticsReportAccessType');
    localStorage.removeItem('isRefreshingToken');
    localStorage.setItem('clientConfig', JSON.stringify(isGTInstance));
    localStorage.setItem('showMoveToArchieve', JSON.stringify(true));
    if (isGTInstance) {
      this.isClientConfig = JSON.parse(localStorage.getItem('clientConfig') ?? 'false');
    } else {
      this.isClientConfig = false
    }
  }

  ngOnInit() {
    const favicon = document.getElementById("favicon");
    if (favicon) {
      favicon.setAttribute("href", this._shared.companyDetails.favicon);
    }
    this.setTitle();
    this._shared.getAppVersion();
    this.router.events.subscribe(event => {
      this.navigationInterceptor(event);
    });
  }


  navigationInterceptor(event: any): void {
    if (!localStorage.getItem('authlogin')) {
      if (event instanceof NavigationCancel) {
        localStorage.setItem('NAVIGATIONKEY', event.url);
      }
    }


    if (event instanceof NavigationStart) {
      const path = event.url ? event.url.toLowerCase() : '';
      const flag = path.includes('app/report/detail') || path.includes('app/payroll/processsalary')
        || path.includes('login') || path.includes('app/processattendance')
        || path.includes('app/candidate-list');
      this._shared.profile = event.url.split('/')[2];
      if (flag) {
        this.isPageLoading = true;
      }
    }
    if (event instanceof NavigationEnd || event instanceof NavigationCancel ||
      event instanceof NavigationError) {
      this.isPageLoading = false;
    }

  }

  getClientDomainValues() {

  }
  public setTitle() {
    this.titleService.setTitle(this._shared.companyDetails.title);
  }

  isMobileViewNew(isMobile: boolean): void {
    this.isMobile = isMobile;
    this.showRedirectDialogForTeams = !this._shared.isDeployedOnGT && isMobile;
  }

  closeMe(): void {
    this.mobileDisclaimerShown = true
  }
}
